/* ============================================================
   ZIVA VIVA — Main Script
   ============================================================ */

// -- Nav Badges (Shopify cart + local saved designs) ------------------------
(function initNavBadges() {
  function setBadge(selector, count, uniqueClass) {
    document.querySelectorAll('.' + uniqueClass).forEach(el => el.remove());
    if (count <= 0) return;
    const link = document.querySelector(selector);
    if (!link) return;
    const b = document.createElement('span');
    b.className = uniqueClass + ' nav__cart-badge';
    b.textContent = count;
    link.style.position = 'relative';
    link.appendChild(b);
  }

  function updateSavedBadge() {
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem('zv_saved') || '[]'); } catch (e) {}
    setBadge('[aria-label="Saved Designs"]', saved.length, 'nav__saved-count');
  }

  async function updateCartBadge() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('cart fetch failed');
      const cart = await res.json();
      setBadge('[aria-label="Cart"]', cart.item_count || 0, 'nav__cart-count');
    } catch (e) {
      let localCart = [];
      try { localCart = JSON.parse(localStorage.getItem('zv_cart') || '[]'); } catch (err) {}
      setBadge('[aria-label="Cart"]', localCart.length, 'nav__cart-count');
    }
  }

  window.updateZivaCartBadge = updateCartBadge;
  window.updateZivaSavedBadge = updateSavedBadge;
  updateCartBadge();
  updateSavedBadge();
})();

// ── Sticky Header ──────────────────────────────────────────────
const header = document.getElementById('header');

const isHomePage = window.location.pathname === '/' ||
                   window.location.pathname.endsWith('index.html') ||
                   window.location.pathname === '';

function updateHeader() {
  if (!isHomePage) {
    header.classList.add('scrolled');
    return;
  }
  if (window.scrollY > 80) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}

window.addEventListener('scroll', updateHeader, { passive: true });
updateHeader();

// ── Scroll Reveal ──────────────────────────────────────────────
const revealSelectors = '.reveal, .reveal-left, .reveal-right';
const revealEls = document.querySelectorAll(revealSelectors);

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Stagger children if parent is a grid
        const siblings = [...entry.target.parentElement.children].filter(
          el => el.matches(revealSelectors)
        );
        const index = siblings.indexOf(entry.target);
        entry.target.style.transitionDelay = `${index * 80}ms`;
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
);

revealEls.forEach(el => revealObserver.observe(el));

// ── Smooth Scroll ──────────────────────────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const id = this.getAttribute('href');
    if (id === '#') return;
    const target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      const offset = 72; // header height
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  });
});

// ── Newsletter ─────────────────────────────────────────────────
function handleSubscribe(e) {
  e.preventDefault();
  const form = e.target;
  const input = form.querySelector('input[type="email"]');
  const btn = form.querySelector('button');

  btn.textContent = 'Thank you!';
  btn.style.background = '#C4964A';
  btn.style.borderColor = '#C4964A';
  input.value = '';
  input.disabled = true;

  setTimeout(() => {
    btn.textContent = 'Subscribe';
    btn.style.background = '';
    btn.style.borderColor = '';
    input.disabled = false;
  }, 4000);
}

// ── Parallax Hero ──────────────────────────────────────────────
const heroVideo = document.querySelector('.hero__video');

if (heroVideo) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    if (scrolled < window.innerHeight) {
      heroVideo.style.transform = `translateY(${scrolled * 0.25}px)`;
    }
  }, { passive: true });
}

// ── Product Card Quick View (placeholder) ──────────────────────
document.querySelectorAll('.product-card__overlay .btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const card = btn.closest('.product-card');
    const name = card.querySelector('.product-card__name').textContent;
    const price = card.querySelector('.product-card__price').textContent;
    showQuickView(name, price, card.querySelector('img')?.src, card.getAttribute('href') || '/#collections');
  });
});

function showQuickView(name, price, imgSrc, targetHref = '/#collections') {
  const existing = document.getElementById('quick-view-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'quick-view-modal';
  modal.style.cssText = `
    position: fixed; inset: 0; z-index: 999;
    display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.55); backdrop-filter: blur(4px);
    animation: fadeIn 0.3s ease;
  `;

  modal.innerHTML = `
    <style>
      @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
      @keyframes slideUp { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: none } }
    </style>
    <div style="
      background: #FAF7F5; max-width: 560px; width: 90%; padding: 48px;
      position: relative; animation: slideUp 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
    ">
      <button onclick="document.getElementById('quick-view-modal').remove()" style="
        position: absolute; top: 20px; right: 20px; font-size: 22px;
        cursor: pointer; border: none; background: none; color: #1A1A1A; line-height: 1;
      ">×</button>
      ${imgSrc ? `<img src="${imgSrc}" style="width:100%;height:280px;object-fit:cover;margin-bottom:28px;">` : ''}
      <p style="font:600 10px/1 'Montserrat',sans-serif;letter-spacing:3px;text-transform:uppercase;color:#C4964A;margin-bottom:10px;">ZIVA VIVA</p>
      <h3 style="font:300 28px/1.2 'Cormorant Garamond',serif;margin-bottom:8px;">${name}</h3>
      <p style="font:500 14px/1 'Montserrat',sans-serif;color:#5E5E5E;margin-bottom:28px;">${price}</p>
      <p style="font:300 13px/1.7 'Montserrat',sans-serif;color:#5E5E5E;margin-bottom:32px;">
        Available in gold, rose gold, and sterling silver. Fully customizable with engraving. Ships in 5–7 business days in our signature gift box.
      </p>
      <a href="${targetHref}" onclick="document.getElementById('quick-view-modal').remove()" style="
        display:inline-flex;align-items:center;justify-content:center;
        height:48px;padding:0 32px;background:#1A1A1A;color:#fff;
        font:600 11px/1 'Montserrat',sans-serif;letter-spacing:2.5px;text-transform:uppercase;
        text-decoration:none;transition:background 0.3s;
      " onmouseover="this.style.background='#333'" onmouseout="this.style.background='#1A1A1A'">
        Customize This Piece
      </a>
    </div>
  `;

  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.remove();
  });

  document.body.appendChild(modal);
}
